export default __webpack_public_path__ + "static/media/shuffle-pack-2.6cbe5981.png";